import axios from 'axios';

export default {
  getUsersForAbTesting({ commit, state }, { id, ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/users`,
        params: { ...ctx, ...filter, id },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('insertUsersForAbTesting', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeUserFromAbTesting({ commit, state }, { appInstallId }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/info-for-testing/delete-user`,
        params: { appInstallId },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('removeUserFromAbTestingRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeUserFromAbTestingRequestError');
          reject(err);
        });
    });
  }
};
